import { t } from '@lingui/macro';

import { Page, PageHeader, PanelContainer } from '../../page-framework';
import ReportActions, { ReportActionsContext, useReportActionsContextValue } from './ReportActions';
import ReportsList from './ReportsList';

export const pageId = 'reports';

export default function ReportsPage() {
    const reportActionsContextValue = useReportActionsContextValue();

    return (
        <ReportActionsContext.Provider value={reportActionsContextValue}>
            <Page id={pageId}>
                <PageHeader actions={<ReportActions />} title={t`Scheduled Reports`} />
                <PanelContainer>
                    <ReportsList hideTitle flexHeight />
                </PanelContainer>
            </Page>
        </ReportActionsContext.Provider>
    );
}
